import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconIphoneDuo: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconIphoneDuo"><Path d="M16.25 2.75H5.75C5.19772 2.75 4.75 3.19772 4.75 3.75V20.25C4.75 20.8023 5.19771 21.25 5.75 21.25H16.25C17.9069 21.25 19.25 19.9069 19.25 18.25V5.75C19.25 4.09315 17.9069 2.75 16.25 2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><Circle cx="16" cy="6" r="1" fill="currentColor"/></CentralIconBase>;
});

export default IconIphoneDuo;
